import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import "@configuratorware/configurator-frontendgui/App/setup";
import "@configuratorware/configurator-frontendgui/App/versionInfo";

import { store } from "@configuratorware/configurator-frontendgui/App/Store";
import CustomThemeProvider from "./ThemeProvider";
import Routing from "./Routing";

export const App = () => {
  return (
    <Provider store={store}>
      <CustomThemeProvider>
        <Routing />
      </CustomThemeProvider>
    </Provider>
  );
};

export const render = () => {
  ReactDOM.render(<App />, document.getElementById("root"));
};
